import React, { useState } from "react";
import PdfViewer from "../../../HwManagement/PdfViewer/PdfViewer";
import ZoomableImage from "../../../HwManagement/HomeWork/Pending/QuestionTypes/ZoomableImage";
import { IP } from "../../../internalServer";
import { iconData } from "../../../iconData";

function CheckboxQuestionPrevious({ response, questionNo, isAdaptiveCheck }) {

    const [isClicked, setIsClicked] = useState(false);
    const [responseAttach, setResponseAttach] = useState();
    const [isError, setIsError] = useState(false);
    const [mideaviewer, setMideaviewer] = useState(false);
    const [showAnswer, setShowAnswer] = useState(false);
    const [pedingSubDetail, setPedingSubDetail] = useState({
        pdfView: false,
    });
    const handleRemovePdfVivwer = () => {
        setPedingSubDetail({
            ...pedingSubDetail,
            pdfView: false,
        });
    };
    console.log("questionNo", questionNo);
    console.log("response", response);

    const handleClick = (attachment) => {
        setResponseAttach(attachment);
        setIsClicked(!isClicked);
    };

    const handleClickforpdf = (fileUrl) => {
        setTimeout(() => {
            setResponseAttach(fileUrl);
            setMideaviewer(true);
        }, 100)
    };

    const getExtension = (file) =>
        file?.split(".").pop()?.toLowerCase();

    const isImage = (file) =>
        ["jpg", "jpeg", "png"].includes(getExtension(file));
    return (
        <>
            {response && (<div className="containerBelowQuestion">
                <div className="d-flex justify-content-between">
                    <div className="Question">
                        Q{questionNo}. {response?.title?.split("\n").map((line, index) => (
                            <React.Fragment key={index}>
                                {index !== 0 && <br />}
                                <span style={index !== 0 ? { marginLeft: "30px", display: "inline-block" } : {}}>
                                    {line}
                                </span>
                            </React.Fragment>
                        ))}
                        {response?.is_mandatory && (
                            <span style={{ marginLeft: "20px", color: "#AC1616", fontSize: "10px", fontWeight: "700" }}>
                                *Mandatory
                            </span>
                        )}
                    </div>
                    {/* <div className="marksQue">
            {response?.correct_score} Marks
          </div> */}
                </div>
                {/* <div className='mt-3'>
                <img src='/HwImg/ImgQuetype.png' alt='img'></img>
            </div> */}

                {response?.attachments?.length > 0 &&
                    response?.attachments.map((attachment, index) => {
                        const ext = getExtension(attachment);
                        const fullUrl = attachment.startsWith("http")
                            ? attachment
                            : `${IP}${attachment}`;

                        return (
                            <div key={index}>
                                {isImage(attachment) ? (
                                    /* ===== IMAGE ===== */
                                    <img
                                        className="mt-3 imageWidthAndHeight"
                                        style={{ cursor: "pointer" }}
                                        src={IP + attachment}
                                        alt="Attachment"
                                        onClick={() => {
                                            handleClick(attachment);
                                        }}
                                    />
                                ) : (
                                    /* ===== PDF / OTHER FILE ===== */
                                    <div
                                        className="mt-2 pdfContainer gap-2 p-2 d-flex"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            handleClickforpdf(attachment);
                                        }}
                                    >
                                        <div className="d-flex align-items-center">
                                            <img
                                                className="extention_icon"
                                                src={
                                                    iconData?.find((i) => i.extension === ext)?.icon
                                                }
                                                alt="file"
                                            />
                                        </div>

                                        <div className="w-75">
                                            <div className="pdfName">
                                                {attachment.replace(/^[^_]*_/, "")}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                <div className="mt-3 optionContainer" style={{ width: isAdaptiveCheck ? "87%" : "60%" }}>
                    {response?.options?.length > 0 &&
                        response?.options?.map((option) => {
                            return (
                                <>
                                    <div
                                        key={option?.key}
                                        className={`d-flex justify-content-between align-items-center mb-1 ${response?.correct_answers?.map(
                                            (cAnswer) =>
                                                cAnswer?.option_key === option?.key
                                                    ? showAnswer ? "totalContainerCheckboxCorrectAnswer" : "totalContainerCheckboxCorrectAnswerWithoutBackground"
                                                    : cAnswer?.option_key !==
                                                        response?.question_response?.answer?.key &&
                                                        response?.question_response?.answer?.key === option?.key
                                                        ? "totalContainerCheckboxWrongAnswer"
                                                        : "totalContainerCheckboxNotAnswer"
                                        )}`}
                                    >
                                        <div className="d-flex align-items-center gap-3 ">
                                            <div className="d-flex gap-2">
                                                {option?.key + ". "}
                                                <input
                                                    type="checkbox"
                                                    readOnly
                                                    checked={
                                                        response?.question_response?.answer?.key ===
                                                        option?.key ||
                                                        showAnswer && response?.correct_answers?.some(
                                                            (cAnswer) => cAnswer?.option_key === option?.key
                                                        ) ||
                                                        false
                                                    }
                                                    className={`${response?.correct_answers?.some(
                                                        (cAnswer) => cAnswer?.option_key === option?.key
                                                    )
                                                        ? showAnswer && "CorrectAnswerCheckbox"
                                                        : "WrongAnswerCheckbox"
                                                        } d-flex align-items-center mt-1`}
                                                />
                                            </div>

                                            <div className="QueOptionsChecked d-flex align-items-center">
                                                {option?.value}
                                            </div>
                                        </div>
                                        {response?.question_response?.answer?.key === option?.key && (
                                            <div
                                                className={`mb-2 ${response?.correct_answers?.map(
                                                    (cAnswer) =>
                                                        cAnswer?.option_key === option?.key
                                                            ? "CorrectAnswerText"
                                                            : "yourAnswerText"
                                                )}`}
                                            >
                                                Your answer
                                            </div>
                                        )}
                                        {showAnswer && response?.correct_answers
                                            ?.length > 0 &&
                                            response?.correct_answers?.map(
                                                (cAnswer) =>
                                                    cAnswer?.option_key === option?.key && (
                                                        <div className="CorrectAnswerText">Correct Answer </div>
                                                    )
                                            )}
                                    </div>
                                    <div className="ml-8">
                                        {option.attachment && (() => {
                                            const fileUrl =
                                                typeof option.attachment === "string"
                                                    ? option.attachment
                                                    : option.attachment?.url;

                                            if (!fileUrl) return null;

                                            const fileType = fileUrl.split(".").pop().toLowerCase();
                                            const isImage = ["jpg", "jpeg", "png"].includes(fileType);
                                            const isVideo = ["mp4", "mov"].includes(fileType);
                                            const isPdf = fileType === "pdf";

                                            const fileIcon =
                                                iconData?.find((i) => i.extension === fileType)?.icon ||
                                                "/images/file_icon.png";

                                            const fullUrl = fileUrl.startsWith("http")
                                                ? fileUrl
                                                : `${IP}${fileUrl}`;

                                            return (
                                                <div className="d-flex flex-row align-items-center me-3">
                                                    {/* ===== Preview ===== */}
                                                    {isImage ? (
                                                        <ZoomableImage src={option.attachment} />
                                                    ) : isVideo ? (
                                                        <video
                                                            src={fullUrl}
                                                            style={{
                                                                width: "60px",
                                                                height: "50px",
                                                                borderRadius: "6px",
                                                                marginBottom: "5px",
                                                            }}
                                                            controls
                                                        />
                                                    ) : isPdf ? (
                                                        <div
                                                            onClick={() => handleClickforpdf(fileUrl)}
                                                            style={{
                                                                width: "100px",
                                                                height: "50px",
                                                                background: "#f5f5f5",
                                                                borderRadius: "6px",
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                margin: "6px 0px"
                                                            }}
                                                        >
                                                            <img
                                                                src={fileIcon}
                                                                alt="pdf"
                                                                style={{ width: "24px", height: "24px" }}
                                                            />
                                                            <div className="hw_default_attach_name">
                                                                <span>
                                                                    {option.attachment?.replace(/^[^_]*_/, "")}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <a
                                                            href={`https://docs.google.com/gview?url=${encodeURIComponent(
                                                                fullUrl
                                                            )}&embedded=true`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ textDecoration: "none" }}
                                                        >
                                                            <div
                                                                style={{
                                                                    width: "100px",
                                                                    height: "50px",
                                                                    background: "#f5f5f5",
                                                                    borderRadius: "6px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                }}
                                                            >
                                                                <img
                                                                    src={fileIcon}
                                                                    alt="file"
                                                                    style={{ width: "24px", height: "24px" }}
                                                                />
                                                            </div>
                                                        </a>
                                                    )}
                                                </div>
                                            );
                                        })()}
                                    </div>
                                </>
                            )
                        })}
                </div>
                <div className="mt-2">
                    <button
                        onClick={() => setShowAnswer(!showAnswer)}
                        className="font-semibold text-orange-600"
                    >
                        {showAnswer ? "Hide Answer" : "Show Answer"}
                    </button>
                </div>
                {
                    isAdaptiveCheck ? null : (
                        <div className="mt-2 pt-2">
                            <div className="TeacherRemarkHeader">TEACHER'S REMARK</div>
                            {response?.comment ? (
                                <div className="TeacerRemarkText mt-2">{response?.comment}</div>
                            ) : (
                                <div className=" TeacerRemarkText mt-2">No Remarks</div>
                            )}
                        </div>
                    )
                }


            </div >)}
            {
                mideaviewer && (
                    <PdfViewer
                        closeMideaviewer={setMideaviewer}
                        attachment={responseAttach}
                    />
                )
            }

            {isClicked &&
                (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
                    <div className="fullSizeImg ">
                        <div className="SubfullSizeImg">
                            <video className="videoPlayer" controls>
                                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
                            </video>
                            <div>
                                <img
                                    className="crossIconImgQue"
                                    onClick={handleClick}
                                    src="/DCM-img/crossIcon.svg"
                                    alt="Up Arrow"
                                />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="fullSizeImg ">
                        <div className="SubfullSizeImg">
                            {
                                !isError || responseAttach.split(".").pop() === "pptx" || responseAttach.split(".").pop() === "PPTX" || responseAttach.split(".").pop() === "PPT" || responseAttach.split(".").pop() === "PPT" ? (
                                    <>
                                        <img
                                            className="imgMain"
                                            src={IP + responseAttach?.replace(/^\./, "")}
                                            alt="Full-size"
                                            onError={(e) => {
                                                setIsError(true)
                                            }}
                                        />
                                        <div>
                                            <img
                                                className="crossIconImgQue"
                                                onClick={() => {
                                                    handleClick()
                                                    setIsError(false)
                                                }}
                                                src="/images/cross.png"
                                                alt="Up Arrow"
                                            />
                                        </div>
                                    </>
                                ) : (
                                    <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>
                                        <img
                                            onClick={handleClick}
                                            src="/images/cross.png"
                                            alt="Up Arrow"
                                            style={{ position: "absolute", top: "75px", right: "40%" }}
                                        />
                                        <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                                        <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                ))}
        </>
    );
}

export default CheckboxQuestionPrevious;
